<template>
  <div class="content">
    <div class="title">学校管理列表</div>
    <div class="header-search">
      <el-input v-model="option.keywordStr" placeholder="输入关键字搜索…" class="input">
        <template #prefix>
          <i class="el-input__icon el-icon-search"></i>
        </template>
      </el-input>
      <el-button @click="getPagedUserList" class="btn-search"><img src="../../content/img/search.png" /></el-button>
    </div>
    <div class="table">
      <div class="table-box">
        <div class="search-change">
          <el-row>
            <el-col :span="10">
              <div class="grid-content bg-purple">
                <!-- <el-button style="background-color:#20a474;color:white;border-radius:10px;"><el-icon size="14"><i-refresh /></el-icon>刷新表格</el-button> -->
                <img src="../../content/img/refresh.png" class="btn-refresh" @click="getPagedUserList" />
                <!-- <img
                  src="../../content/img/delete.png"
                  class="btn-refresh" style="margin-left:20px;"
                  @click="batchDeleteUser"
                /> -->
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                状态：<el-checkbox @change="getPagedUserList" v-model="checked.checked1" label="通过"
                  fill="#000000"></el-checkbox>
                <el-checkbox @change="getPagedUserList" v-model="checked.checked2" label="未过"></el-checkbox><el-checkbox
                  @change="getPagedUserList" v-model="checked.checked3" label="待审"></el-checkbox>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="grid-content bg-purple">
                <!-- <el-button @click="getPagedUserList"
                  ><span class="blue">搜索</span></el-button
                ><el-button @click="resetSearch">重置</el-button> -->
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="table-pagination">
          <el-table :data="tableData.models" height="538" @select-all="selectAll($event)" @select="select($event)">
            <!-- <el-table-column type="selection" /> -->
            <el-table-column prop="SchoolNo" label="学校编码" show-overflow-tooltip />
            <el-table-column prop="SchoolName" label="学校名称" style="width: 150px" show-overflow-tooltip />
            <el-table-column prop="UserName" label="联系人姓名" width="100" show-overflow-tooltip />
            <el-table-column prop="Phone" label="手机号码" show-overflow-tooltip />
            <el-table-column prop="Email" label="邮箱" show-overflow-tooltip />
            <el-table-column label="证明附件" width="100">
              <template #default="scope">
                <div style="width: 50px" v-if="scope.row.FilePath != '' && scope.row.FilePath != null">
                  <img src="../../content/img/text.png" style="height: 16px; width: 16px; line-height: 20px" alt="" />
                  <a target="_blank" :href="scope.row.FilePath" style="color: rgb(0, 0, 0, 0.6)">
                    <div style="
                        display: inline;
                        float: right;
                        margin-top: -3px;
                        padding-top: -3px;
                      ">
                      附件
                    </div>
                  </a>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="60">
              <template #default="scope">
                <span v-if="scope.row.Status == 0">
                  <img src="../../content/img/wait.png" />
                </span>
                <span v-else-if="scope.row.Status == 1">
                  <img src="../../content/img/through.png" />
                </span>
                <span v-else-if="scope.row.Status == 2">
                  <img src="../../content/img/notOver.png" />
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template #default="scope">
                <span v-if="scope.row.Status == 0" class="cursor blue" @click="review(scope.row)">审核</span>
                <span v-if="scope.row.Status == 1" class="cursor blue" @click="resetPwd(scope.row)">重置密码</span>
                <!-- <span class="blue" v-if="scope.row.Status==0"> | </span>
                <span class="cursor blue" v-if="scope.row.Status==0" @click="deleteUser(scope.row)"
                  >删除</span
                > -->
              </template>
            </el-table-column>
          </el-table>
          <div class="demo-pagination-block table-pagination-page">
            <el-pagination v-model:currentPage="option.PageIndex" :page-sizes="[10, 20, 50, 100]"
              v-model:page-size="option.PageSize" background layout=" total,sizes, prev, pager, next, jumper"
              :total="tableData.total" @size-change="getPagedUserList" @current-change="getPagedUserList">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-drawer v-model="drawer" title="学校信息" :with-header="false" size="40%">
      <div class="info">
        <div class="info-box">学校信息</div>
        <div class="bg-gray"></div>
        <div class="info-title">基本信息</div>
        <div class="info-box">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple info-text">
                编码：<span class="text">{{ schoolInfo.model.SchoolNo }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light info-text">
                联系人：<span class="text">{{
                  schoolInfo.model.UserName
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple info-text">
                学校：<span class="text">{{
                  schoolInfo.model.SchoolName
                }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light info-text">
                邮箱：<span class="text">{{ schoolInfo.model.Email }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple info-text"></div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light info-text">
                手机号：<span class="text">{{ schoolInfo.model.Phone }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="bg-gray"></div>
        <div class="info-box">
          <div>学校证明</div>
          <div class="info-text info-annex">
            证明附件：
            <a :href="url" target="_blank">查看</a>
          </div>
        </div>
        <div class="bg-gray"></div>
        <div class="info-btn">
          <el-button class="blue" @click="throughBtn">通过</el-button>
          <el-button @click="noThroughBtn">不通过</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog v-model="dialogVisible" title="审核通过" width="30%">
      <span>即将发送邮件通知联系人</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="send">发送</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog v-model="dialogVisibleNoThrouth" title="审核不通过" width="30%">
      <span>原因：</span><el-input v-model="data.content" autosize type="textarea"
        placeholder="输入原因后，将以邮件形式发送给联系人，并提示尽快修正提交。" />
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" @click="noThroughSend">发送</el-button>
          <el-button @click="
            dialogVisibleNoThrouth = false;
          data.content = '';
          ">取消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { reactive, ref } from "vue";
import {
  GetUserPageList,
  UpdateUserSatus,
  DeleteUser,
} from "../../http/school.js";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { replace } from '../../utils/replace.js';
import {
  ResetPassword,
} from "../../http/user";
export default {
  setup() {
    const searchImg = require("../../content/img/search.png");
    const resetImg = require("../../content/img/refresh.png");
    let url = ref("");
    let checked = reactive({
      checked1: true,
      checked2: true,
      checked3: true,
    });
    let schoolInfo = reactive({
      model: {},
    });
    let annexPath = require("../../content/img/text.png");
    let drawer = ref(false);
    let dialogVisible = ref(false);
    let dialogVisibleNoThrouth = ref(false);
    let waitImg = require("../../content/img/wait.png");
    let throughImg = require("../../content/img/through.png");
    let noOverImg = require("../../content/img/notOver.png");
    let tableData = reactive({
      models: [],
      total: 0,
    });
    let option = reactive({
      keywordStr: "",
      roleId: "2",
      status: [],
      PageIndex: 1,
      PageSize: 10,
      IsAsc: false,
      SortFields: ["CreateTime"],
    });
    let data = reactive({
      UserId: "",
      status: 0,
      content: "",
    });
    let ids = ref([]);
    const resetSearch = () => {
      option.keywordStr = "";
      checked.checked1 = true;
      checked.checked2 = true;
      checked.checked3 = true;
    };
    const batchDeleteUser = () => {
      ElMessageBox.confirm("你确认要删除吗?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            UserIds: ids.value,
          };
          DeleteUser(data).then((res) => {
            if (res.IsSuccess) {
              ElMessage({
                message: res.SuccessMessage,
                type: "success",
              });
              getPagedUserList();
            } else {
              ElMessage.error(res.ErrorMessage);
            }
          });
        })
        .catch(() => { });
    };
    const deleteUser = (row) => {
      ElMessageBox.confirm("你确认要删除吗?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            UserIds: [row.Id],
          };
          DeleteUser(data).then((res) => {
            if (res.IsSuccess) {
              ElMessage({
                message: res.SuccessMessage,
                type: "success",
              });
              getPagedUserList();
            } else {
              ElMessage.error(res.ErrorMessage);
            }
          });
        })
        .catch(() => { });
    };
    const selectAll = (e) => {
      ids.value = [];
      e.forEach((m) => {
        ids.value.push(m.Id);
      });
    };
    const select = (e) => {
      ids.value = [];
      e.forEach((m) => {
        ids.value.push(m.Id);
      });
    };
    const getPagedUserList = async () => {
      option.status = [];
      if (checked.checked1) {
        option.status.push("1");
      }
      if (checked.checked2) {
        option.status.push("2");
      }
      if (checked.checked3) {
        option.status.push("0");
      }
      GetUserPageList(option)
        .then((res) => {
          if (res.IsSuccess) {
            res.Models.forEach((m) => {
              if (m.FilePath.indexOf('https://hspublicfileoss.oss-cn-beijing.aliyuncs.com/') == -1)
                m.FilePath = 'https://hspublicfileoss.oss-cn-beijing.aliyuncs.com/' + m.FilePath;
            });
            tableData.models = res.Models;
            tableData.models.forEach(m => {
              m.FilePath = replace(m.FilePath)
            })
            tableData.total = res.TotalCount;
          } else {
            ElMessage.error(res.ErrorMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    //通过
    const throughBtn = () => {
      dialogVisible.value = true;
    };
    const noThroughBtn = () => {
      dialogVisibleNoThrouth.value = true;
    };
    const send = () => {
      (data.UserId = schoolInfo.model.Id), (data.status = 1);
      data.content = "";
      UpdateUserSatus(data).then((res) => {
        if (res.IsSuccess) {
          drawer.value = false;
          dialogVisible.value = false;
          ElMessage({
            message: res.SuccessMessage,
            type: "success",
          });
          getPagedUserList();
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };
    const noThroughSend = () => {
      data.UserId = schoolInfo.model.Id;
      data.status = 2;
      const loading = ElLoading.service({
        lock: true,
        text: "发送中······",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UpdateUserSatus(data).then((res) => {
        if (res.IsSuccess) {
          drawer.value = false;
          dialogVisible.value = false;
          dialogVisibleNoThrouth.value = false;
          data.content = "";
          ElMessage({
            message: res.SuccessMessage,
            type: "success",
          });
          getPagedUserList();
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
      loading.close();
    };
    //审核
    const review = (row) => {
      schoolInfo.model = row;
      drawer.value = true;
      url.value = row.FilePath;
    };
    getPagedUserList();
    let loading;
    const resetPwd = (row) => {
      ElMessageBox.confirm("你确认要重置密码吗?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        ResetPassword({ UserIds: [row.Id] }).then((res) => {
          loading = ElLoading.service({
            lock: true,
            text: "操作中······",
            background: "rgba(0, 0, 0, 0.7)",
          });
          if (res.IsSuccess) {
            getPagedUserList();
            ElMessage({
              message: res.SuccessMessage,
              type: "success",
            });
            loading.close();
          } else {
            ElMessage.error(res.ErrorMessage);
            loading.close();
          }
        }).catch(() => {
          loading.close();
        });
      }).catch(() => {

      })

    };
    // let clientOSS = client();
    // const response = {
    //   "content-disposition": `inline`,
    // };
    // const getUrl = (path) => {
    //    let filename = 'dff6bc36-0056-4889-9a4c-28ee44a23773.pdf'; // 自定义下载后的文件名。
    //     let response = {
    //       'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`
    //     }
    //     path='Important/SignUP/StudentCertificationDocuments/e280e6c5-f3d8-4838-a5da-698e081107442021%201115%20%E5%BF%83%E7%90%86%E5%AD%A6%E7%B1%BB%E4%B8%93%E4%B8%9A%E6%95%99%E5%AD%A6%E6%8C%87%E5%AF%BC%E5%A7%94%E5%91%98%E4%BC%9A%E6%95%99%E6%94%B9%E7%AB%8B%E9%A1%B9%E9%80%9A%E7%9F%A5(1)(1).pdf?uploadId=B30BF8B1B50F42B3827F306B1F313A7C';
    //    console.log(path.substring(0,path.indexOf('?')))
    //   path='https://hspublicfileoss.oss-cn-beijing.aliyuncs.com/Important/SignUP/StudentCertificationDocuments/8497c766-0edf-4436-a549-e46c162ae0f02021%201115%20%E5%BF%83%E7%90%86%E5%AD%A6%E7%B1%BB%E4%B8%93%E4%B8%9A%E6%95%99%E5%AD%A6%E6%8C%87%E5%AF%BC%E5%A7%94%E5%91%98%E4%BC%9A%E6%95%99%E6%94%B9%E7%AB%8B%E9%A1%B9%E9%80%9A%E7%9F%A5(1)(1).pdf?uploadId=358CABAB6EBA4A298270A992A972E4F8';
    //     console.log(clientOSS.signatureUrl( path,{response}));
    //   return clientOSS.signatureUrl(path, { response });
    // };

    return {
      resetPwd,
      searchImg,
      resetImg,
      checked,
      option,
      getPagedUserList,
      tableData,
      waitImg,
      review,
      throughImg,
      noOverImg,
      resetSearch,
      drawer,
      schoolInfo,
      throughBtn,
      dialogVisible,
      send,
      noThroughBtn,
      noThroughSend,
      dialogVisibleNoThrouth,
      data,
      url,
      annexPath,
      deleteUser,
      selectAll,
      select,
      ids,
      batchDeleteUser,
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin-left: 10px;
}

.title {
  margin-top: 0px;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: var(--h-228-s-8-l-24);
}

.header-search {
  width: 265px;
  margin-top: 20px;
}

.input {
  width: 200px;
  margin-left: 15px;
}

.btn-search {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  float: right;
}

.table {
  margin-top: 20px;
  border-radius: 20px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.12);
  background-color: var(--h-0-s-0-l-100);
  width: 85%;
  min-width: 800px;
  height: 100%;
  max-height: 756px;
}

.table-box {
  padding-top: 10px;
  width: 90%;
  margin: 0 auto;

  .btn-refresh {
    cursor: pointer;
  }

  .text-balck {
    >span {
      color: black;
    }
  }

  .table-pagination-page {
    margin-top: 16px;
    padding-bottom: 20px;
  }
}

.blue {
  color: #409eff;
}

.cursor {
  cursor: pointer;
}

.info {
  width: 90%;
  margin: 0 auto;

  .info-title {
    margin-top: 30px;
  }

  .info-box {
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .info-text {
    margin-top: 20px;
    font-size: 13px;
  }

  .text {
    color: rgb(0, 0, 0, 0.8);
    font-size: 13px;
  }

  .info-btn {
    margin-top: 50px;
  }

  .bg-gray {
    background-color: #ececec;
    height: 1px;
    width: 100%;
  }

  .info-annex {
    >a {
      text-decoration: none;
      color: #409eff;
    }
  }
}
</style>
<style>
.table-pagination td {
  padding: 9px 0 !important;
}
</style>